export interface BroadcastState {
  isLive: boolean;
  sessionId?: string;
  trackId?: string;
  startedAt?: number;
  title?: string;
  speaker?: string;
  isDemo: boolean;
  activeListeners: number;
  error?: string;
}

function optionalId(value: unknown): string | undefined {
  if (typeof value !== "string") return undefined;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
}

export function broadcastStateFromJson(json: Record<string, unknown>): BroadcastState {
  return {
    isLive: (json.isLive as boolean | undefined) ?? false,
    sessionId: optionalId(json.sessionId),
    trackId: optionalId(json.trackId),
    startedAt: json.startedAt as number | undefined,
    title: optionalId(json.title),
    speaker: optionalId(json.speaker),
    isDemo: (json.isDemo as boolean | undefined) ?? true,
    activeListeners: (json.activeListeners as number | undefined) ?? 0,
    error: json.error as string | undefined,
  };
}

export function broadcastStateOffline(): BroadcastState {
  return {
    isLive: false,
    isDemo: true,
    activeListeners: 0,
  };
}

export function broadcastStateToJson(state: BroadcastState): Record<string, unknown> {
  return {
    isLive: state.isLive,
    sessionId: state.sessionId,
    trackId: state.trackId,
    startedAt: state.startedAt,
    isDemo: state.isDemo,
    activeListeners: state.activeListeners,
    ...(state.title != null ? { title: state.title } : {}),
    ...(state.speaker != null ? { speaker: state.speaker } : {}),
    ...(state.error != null ? { error: state.error } : {}),
  };
}
